module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Light.ac7c5723.woff2";